<script>
import { Bar } from 'vue-chartjs';
import moment from 'moment';

export default {
    extends: Bar,
    async mounted() {
        const { data: subscribes } = await axios.get('/admin/kpi/rating-register');

        this.renderChart({
            labels: subscribes.map(row => {
                    return row.label;
            }),
            datasets: [
                {
                    label: 'Cadastro',
                    //backgroundColor: '#f87979',
                    data: subscribes.map(row => row.total),
                }
            ]
        }, {responsive: true, maintainAspectRatio: false});
    }
}
</script>
